<template>
  <div
    class="modal set-variables-panel right-sliding-panel right-sliding-panel-xs"
    :class="[
      { 'show d-block': show },
      { 'd-none': !show },
      { 'modal-mini': type === 'mini' }
    ]"
    v-show="show"
    tabindex="-1"
    role="dialog"
    :aria-hidden="!show"
  >
    <div class="modal-dialog mb-0">
      <div class="modal-content">
        <modal-topbar>
          <a slot="left" @click="closePanel">
            <i class="fas fa-chevron-left mr-1"></i>
            <span>Settings</span>
          </a>
          <div slot="center">Variables</div>
        </modal-topbar>

        <div class="modal-body main-content--pricing">
          <ul class="panel-blocks mt-5">
            <li class="panel-item">
              <p>
                The IMV (Impressions Money Value) is the monetary value
                associated to 1,000 impressions of a campaign. This varies from
                industry to industry and also depends on what you promote.
              </p>
            </li>
            <li class="panel-item">
              <div class="mb-2 setting-label mt-1">
                <span class=" nav-link-text">Currency</span>
              </div>

              <div class="select-container d-flex">
                <multiselect
                  v-if="currenciesListForDropdown"
                  placeholder="Currency"
                  :searchable="true"
                  selectLabel
                  deselectLabel
                  selectedLabel
                  :allow-empty="false"
                  label="description"
                  track-by="code"
                  :hide-selected="true"
                  v-model="currency"
                  :options="currenciesListForDropdown"
                  :class="!isValidCurrency && localError ? 'error' : ''"
                />
              </div>
            </li>
            <li class="panel-item mt-3">
              <div class="mb-2 setting-label">
                <span class=" nav-link-text">IMV</span>
              </div>
              <base-input
                class="input-group-alternative mb-4"
                placeholder="0"
                v-model="imvCoef"
                type="text"
              ></base-input>
            </li>
          </ul>
          <div class="flex-middle-center">
            <base-button
              type="primary"
              class="btn-w-25 mr-4"
              v-on:click="closePanel"
              >Close</base-button
            >
            <base-button
              type="primary"
              class="btn-w-25"
              v-on:click="setVariables"
              >Save</base-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";
import { MESSAGES } from "@/constants";

export default {
  name: "set-variables-panel",
  components: {
    Multiselect
  },
  props: {
    currenciesList: {
      type: Array
    },
    show: Boolean,
    type: {
      type: String,
      default: "",
      validator(value) {
        let acceptedValues = ["", "notice", "mini"];
        return acceptedValues.indexOf(value) !== -1;
      },
      description: 'Modal type (notice|mini|"") '
    },
    animationDuration: {
      type: Number,
      default: 500,
      description: "Modal transition duration"
    },
    username: {
      type: String
    }
  },
  data() {
    return {
      loading: {
        profile: false,
        currencies: false
      },
      currency: null,
      imvCoef: 0,
      localError: false
    };
  },
  computed: {
    ...mapState({
      showAlert: state => state.alert.showAlert,
      defaultCurrency: state => state.user.authUser.default_currency,
      defaultImvCoefficient: state => state.user.authUser.default_imv_coef
    }),
    isValidCurrency: {
      get() {
        return this.currency ? true : false;
      }
    },
    currenciesListForDropdown: {
      get() {
        return this.currenciesList.map(e => {
          return { code: e.code, description: e.code + " - " + e.description };
        });
      }
    }
  },
  methods: {
    closePanel() {
      /* slide out panel */
      document.querySelector(
        ".set-variables-panel .modal-dialog"
      ).style.right = `-100%`;
      /* reset panel */
      setTimeout(() => {
        this.$emit("update:show", false);
        this.$emit("close");
      }, this.animationDuration / 2);
    },
    selectCard(type, param) {
      this.$emit("selectCard", { type: type, param: param });
    },
    async setVariables() {
      this.loading.profile = true;
      try {
        await this.$store.dispatch("user/setCustomizations", {
          default_imv_coef: this.imvCoef,
          default_currency: "USD"
        });
      } catch {
        this.loading.profile = false;
        if (!this.showAlert) {
          this.$store.dispatch("setAlert", {
            showAlert: true,
            content: MESSAGES['common-500'],
            alertClass: "danger"
          });
        }
      }
    }
    // async getCurrenciesList() {
    //   if (this.currencies.length > 0) return;
    //   this.loading.currencies = true;
    //   try {
    //     await this.$store.dispatch(
    //       "user/getCurrenciesList"
    //     );
    //     this.loading.currencies = false;
    //     this.localError = null;
    //   } catch {
    //     this.loading.currencies = false;
    //     if (!this.settingError) {
    //       this.localError = MESSAGES["user__get_currencies-failed"];
    //     }
    //   }
    // }
  },

  watch: {
    show(val) {
      const documentClasses = document.body.classList;
      if (val) {
        this.localError = false;
        const defaultCurrencyIndex = this.currenciesList
          .map(e => e.code)
          .indexOf(this.defaultCurrency);
        this.currency = this.currenciesListForDropdown[defaultCurrencyIndex];
        /* slide in panel*/
        documentClasses.add("modal-open");
        setTimeout(() => {
          document.querySelector(
            ".set-variables-panel .modal-dialog"
          ).style.right = `0px`;
          this.imvCoef = this.defaultImvCoefficient;
        }, 0);
      } else {
        /* reset panel */
        documentClasses.remove("modal-open");
        document.querySelector(".set-variables-panel").scrollTop = 0;
      }
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.modal.show {
  background-color: rgba(255, 255, 255, 0.7);
}
</style>
